import { createAsyncThunk } from '@reduxjs/toolkit';
import { apiGet, apiPost } from 'api-service';

export const fetchQuestion = createAsyncThunk(
  'feedbackReducer/fetchQuestion',
  async ({ slug }, thunkAPI) => {
    try {
      const response = await apiGet(
        `/search/api/v1/feedback/question/${slug}/feedback`
      );
      return response.data.result.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const postFeedbackResponse = createAsyncThunk(
  'feedbackReducer/postFeedbackResponse',
  async (params = {}, thunkAPI) => {
    try {
      await apiPost('/search/api/v1/feedback/response/feedbackResponse', {
        ...params,
      });
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const fetchFeedbackResponses = createAsyncThunk(
  'feedbackReducer/fetchFeedbackResponses',
  async ({ slug, params }, thunkAPI) => {
    try {
      const response = await apiGet(
        `/search/api/v1/feedback/question/${slug}/responses`,
        {
          ...params,
        }
      );
      return response.data.result.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);
